import { KreditlinieStaticEntry } from './kreditlinie-static-entry.model';

export class KreditlinieStatic {

    kreditlinien: KreditlinieStaticEntry[] = [];

    public doDeserialize(input: any): KreditlinieStatic {
        this.kreditlinien = [];

        if (input?.['kreditlinien']) {
            for (const entry of input['kreditlinien']) {
                const entryObj = new KreditlinieStaticEntry();
                entryObj.buergschaftsLinie = entry['buergschaftsLinie'];
                entryObj.hoechstBetragPercent = entry['hoechstBetragPercent'];
                entryObj.jahresBeitrag = entry['jahresBeitrag'];

                this.kreditlinien.push(entryObj);
            }
        }

        return this;
    }

    getEntry(buergschaftsLinie: string): KreditlinieStaticEntry {
        for (const entry of this.kreditlinien) {
            if (entry.buergschaftsLinie === +buergschaftsLinie) {
                return entry;
            }
        }

        return null;
    }

}
